import MaxLengthNumericEditor from '../CustomAgGridEditor/inputComponent';
import * as Styles from '../CommonConstants/commonConstants';

export const clientTableHead = [
  {
    headerName: 'Client ID',
    field: 'clientId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    cellStyle: {
      'border-right-color': Styles.BorderColor,
      display: 'flex',
      alignItems: 'center',
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Client Name',
    field: 'clientName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    resizable: false,
    cellStyle: {
      'border-right-color': Styles.BorderColor,
      display: 'flex',
      alignItems: 'center',
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const rebateProgramTableHead = [
  {
    headerName: 'Rebate Program CD',
    field: 'rebateProgramCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: {
      'border-right-color': Styles.BorderColor,
      display: 'flex',
      alignItems: 'center',
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Description',
    field: 'shortDescr',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: {
      'border-right-color': Styles.BorderColor,
      display: 'flex',
      alignItems: 'center',
    },
    filter: 'agTextColumnFilter',
    resizable: false,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const superClientTableHead = [
  {
    headerName: 'Super Client Name',
    field: 'superClientName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_1000,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: {
      'border-right-color': Styles.BorderColor,
      display: 'flex',
      alignItems: 'center',
    },
    filter: 'agTextColumnFilter',
    resizable: false,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const groupTableHead = [
  {
    headerName: 'Client/Group ID',
    field: 'groupId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: {
      'border-right-color': Styles.BorderColor,
      display: 'flex',
      alignItems: 'center',
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Group Name',
    field: 'groupName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    resizable: false,
    cellStyle: {
      'border-right-color': Styles.BorderColor,
      display: 'flex',
      alignItems: 'center',
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const groupTableHeadCC = [
  {
    headerName: 'Client/Group ID',
    field: 'cg_id',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: {
      'border-right-color': Styles.BorderColor,
      display: 'flex',
      alignItems: 'center',
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    sort: 'asc',
    sortingOrder: ['desc', 'asc'],
  },
  {
    headerName: 'Group Name',
    field: 'groupName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'nameRenderGroup',
    cellClass: 'frr-ellipsis-text-overlap',
    maxLength: Styles.Length_30,
    resizable: false,
    cellStyle: {
      'border-right-color': Styles.BorderColor,
      display: 'flex',
      alignItems: 'center',
      cellClass: 'frr-ellipsis-text-overlap',
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const contactGroupTableHead = [
  {
    headerName: 'Group ID',
    field: 'groupId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'CustomNavigationComponent',
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Group Name',
    field: 'groupName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Start Date',
    field: 'startDt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'End Date',
    field: 'endDt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    resizable: false,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const superClientModalHead = [
  {
    headerName: 'Client ID',
    field: 'clientId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Client Name',
    field: 'clientName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'nameRenderClient',
    cellClass: 'frr-ellipsis-text-overlap',
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    resizable: false,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const superClientModalHeadCC = [
  {
    headerName: 'Client ID',
    field: 'clientId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Client Name',
    field: 'clientName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    resizable: false,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const manuFactureHead = [
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'nameRenderMFG',
    cellClass: 'frr-ellipsis-text-overlap',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    resizable: false,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
export const manuFactureHeadRecordMailing = [
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellClassRules: {
      'yellow-legend': (params) => params.data?.invoiceMailedDt !== null,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'nameRenderMFG',
    cellClass: 'frr-ellipsis-text-overlap',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    resizable: false,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellClassRules: {
      'yellow-legend': (params) => params.data?.invoiceMailedDt !== null,
    },
  },
];

export const providerHead = [
  {
    headerName: 'Provider ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Provider Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'nameRenderMFG',
    cellClass: 'frr-ellipsis-text-overlap',
    resizable: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const ineligibleProvidersHead = [
  {
    headerName: 'Provider ID Type',
    field: 'mfgId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 100,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Provider ID',
    field: 'mfgName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 100,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Provider Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 100,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Ineligibility Period Start Date',
    field: 'mfgName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 100,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Ineligibility Period End Date',
    field: 'mfgName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 100,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Actions',
    field: 'mfgName',
    filter: false,
    sortable: false,
    suppressMenu: false,
    minWidth: 100,
    resizable: false,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const clientGroupPlanHead = [
  {
    headerName: 'Client/Group/Plan',
    field: 'cgpId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor, display: 'block' },
    cellClass: 'frr-ellipsis-text-overlap',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Plan Name',
    field: 'planName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    resizable: false,
    cellRenderer: 'nameRenderPlan',
    cellClass: 'frr-ellipsis-text-overlap',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const contractTableHead = [
  {
    headerName: 'Contract ID',
    field: 'contractNum',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor, display: 'block' },
    cellClass: 'frr-ellipsis-text-overlap',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Contract Name',
    field: 'contractName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellRenderer: 'nameRenderContract',
    cellClass: 'frr-ellipsis-text-overlap',
    cellStyle: { 'border-right-color': Styles.BorderColor, display: 'block' },
    filter: 'agTextColumnFilter',
    resizable: false,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const manuFactureChildHead = [
  {
    headerName: 'Type',
    field: 'contactTypeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor, display: 'block' },
    cellClass: 'frr-ellipsis-text-overlap',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Contact Name',
    field: 'contactName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'nameRenderChild',
    cellClass: 'frr-ellipsis-text-overlap',
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Corp Name',
    field: 'corpName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    resizable: false,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'copNameRender',
    cellClass: 'frr-ellipsis-text-overlap',
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor, display: 'block' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
